
<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <div id="AddEstimations">

    <!-- <simulation-wizzard :currentTab="currentTab"></simulation-wizzard> -->

    <div
      class="
        d-flex
        flex-column
        align-items-start
        flex-md-row
        align-items-md-center
        min-h
      "
    >
      <h2 class="text-primary mb-4 mr-3 font-40px">{{ edit ? simulation.name : $t("perform_new_simulation") }}</h2>
    </div>

    <div v-disable-all-after-carried-out="simulation.status"
         class="cards-group mb-4">
      <b-card no-body class="card-collapse border-0 box-shadow-sm">
        <div
          class="btn-collapse"
          style="top: 12px"
          aria-expanded="true"
          @click="colapseCard($event)"
        >
          <b-icon icon="chevron-up" class="fsize-2"></b-icon>
        </div>
        <b-tabs
          ref="tabsAddress"
          pills
          card
          v-tabs-scroll
          class="tabs-collapse"
          nav-class="tabs-scroll"
          v-model="selectedAddress"
          @activate-tab="selectedFiche = 0"
        >
          <b-tab v-for="(address, a) in tabsAddress"
                 :key="'dyn-tab-' + a"
                 :set="addressValidator = $v.tabsAddress.$each[a]"
          >
          
            <template #title>
              <b-button
                variant="danger"
                class="close-tab"
                @click="openConfirmationAdresseModal(address.tabAddressIndex)"
                :hidden="simulation.status === 'TO_BE_TRANSFORMED'"
              >
                <b-icon icon="x" scale="1"></b-icon>
              </b-button>
              {{ "Adresse " + (address.tabAddressIndex+1) }}
            </template>
            <Address :addressValidator="addressValidator"
                     @onZipCodeChange="fetchCityByZipCode"
                     @onCityChange="updatePrecarities"
            ></Address>
          </b-tab>

          <template #tabs-end>
            <b-nav-item
              role="presentation"
              @click.prevent="newTabAdresse"
              href="#"
              class="add-btn"
              :class="{ 'ml-4': tabsAddress.length }"
              :hidden="simulation.status === 'TO_BE_TRANSFORMED'"
            >
              <b-icon icon="plus-circle-fill"></b-icon> {{ $t("add_address") }}
            </b-nav-item>
          </template>

          <!-- Render this if no tabs -->
          <template #empty>
            <div class="text-center text-muted">
              Il n'y a pas d'onglets ouverts<br />
              Ouvrez un nouvel onglet en utilisant le bouton
              <strong>{{ $t("add_address") }}</strong> ci-dessus.
            </div>
          </template>
        </b-tabs>
      </b-card>
      <b-card no-body class="card-collapse border-0 box-shadow-sm">
        <div
          class="btn-collapse"
          style="top: 12px"
          @click="colapseCard($event)"
        >
          <b-icon icon="chevron-up" class="fsize-2"></b-icon>
        </div>
        <b-tabs
          pills
          card
          ref="tabsFiche"
          v-tabs-scroll
          class="tabs-collapse"
          nav-class="tabs-scroll"
          v-model="selectedFiche"
          v-if="tabsAddress.length > 0"
        >
          <b-tab
            v-for="(tabFiche, f) in tabFicheByAddress"
            :key="'dyn-tab-' + f + '-' + tabFiche.addressIndex"
            :set="ficheValidator = $v.tabsFiche.$each[tabsFiche.indexOf(tabFiche)]"
          >
            <template #title>
              <b-button
                variant="danger"
                class="close-tab"
                @click="openConfirmationFicheModal(tabFiche.tabFicheIndex)"
                :hidden="simulation.status === 'TO_BE_TRANSFORMED'"
              >
                <b-icon icon="x" scale="1"></b-icon>
              </b-button>
              {{ "Fiche " + (tabFiche.tabFicheIndex+1) }}
            </template>

              <Fiche
                 v-if="tabFicheByAddress.length"
                :ficheValidator="ficheValidator"
                :tabsFicheValidation="$v.tabsFiche"
                :applicationSectors="applicationSectors"
                :departments="departments"
                :periods="periods"
                :addressFicheIndex="tabFiche"
                :simulationStatus="simulation.status"
                @setPeriod="setPeriods"
                @workTypeBySector="workTypeBySector"
                @fetchFiches="getFiches"
                @fetchPrecarity="fetchPrecarity"
                @getFormConditions="getFormConditions"
                @checkConditions="checkConditions"
              ></Fiche>

          </b-tab>

          <template #tabs-end>
            <b-nav-item
              role="presentation"
              @click.prevent="newTabFiche"
              href="#"
              class="add-btn"
              :class="{ 'ml-4': tabsFiche.length }"
              :hidden="simulation.status === 'TO_BE_TRANSFORMED'"
            >
              <b-icon icon="plus-circle-fill"></b-icon> {{ $t("add_fiche") }}
            </b-nav-item>
          </template>

          <!-- Render this if no tabs -->
          <template #empty>
            <div class="text-center text-muted">
              Il n'y a pas d'onglets ouverts<br />
              Ouvrez un nouvel onglet en utilisant le bouton
              <strong>{{ $t("add_fiche") }}</strong> ci-dessus.
            </div>
          </template>
        </b-tabs>
      </b-card>
    </div>

    <div
      v-if="loading"
      class="
        d-flex
        align-items-center
        justify-content-center
        mb-4
        height-doc
      "
    >
      <b-spinner variant="primary" type="grow" label="Spinning"></b-spinner>
    </div>
    <b-row
      class="documents"
      align-v="stretch"
      v-if="this.simulation.id"
      v-show="!loading"
    >
      <b-col cols="12" lg="8" class="mb-4">
        <b-card class="h-100 border-raduis-xl border-0 box-shadow-sm p-3">
          <h4 class="mb-4">{{ $t("documents") }}</h4>
          <div class="mb-4">
            <documents-actions
              :documents="getDocuments"
              :selectDocuments="selectDocuments"
              :noFilter="true"
              :noSearch="true"
              :isSimulation="true"
              v-on:download="downloadDocuments()"
              :queryConfig="queryConfig"
              @applyFilter="applyFilter($event)"
              @reloadData="applyFilter($event)"
            ></documents-actions>
          </div>
          <documents-list
            :documents="getDocuments"
            :selectDocuments="selectDocuments"
            v-on:selectDocument="selectDocument($event)"
          ></documents-list>
        </b-card>
      </b-col>
      <b-col cols="12" lg="4" class="mb-4">
        <documents-details
          :documents="getDocuments"
          :selectDocuments="selectDocuments"
        ></documents-details>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-card
          class="border-raduis-xl border-0 box-shadow-sm text-center"
          body-class="p-3"
        >
          <b-row>
            <b-col cols="12" sm="6" class="text-sm-right mb-2 mb-sm-0">
              <b-button
                @click="openConfirmLoseModal()"
                pill
                variant="outline-primary"
                class="py-2 px-5"
              >
                <span>{{ $t("cancel") }}</span>
              </b-button>
            </b-col>
            <b-col cols="12" sm="6" class="text-sm-left">
              <b-button
                @click="openConfirmSaveModal()"
                :disabled="saveSimulationLoader || tabsFiche.length === 0 || simulation.status === 'TO_BE_TRANSFORMED'"
                pill
                variant="primary"
                class="py-2 px-5"
              >
                <b-spinner
                  variant="light"
                  small
                  class="mr-2 align-middle"
                  v-if="saveSimulationLoader"
                ></b-spinner>
                <span> {{ $t("save") }}</span>
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <confirm-modal
      :id="modalId"
      :content="$t(modalContent)"
      :loader="confirmLoader"
      fontSize="h3"
      backdrop-close="false"
      @yesClick="modelConfirm()"
      @close="hideConfirmationModal()"
    ></confirm-modal>
    <SimulationInfoModal></SimulationInfoModal>
  </div>
</template>

<script>
import DocumentsActions from '@/components/static/DocumentsActions.vue';
import DocumentsList from '@/components/static/DocumentsList.vue';
import DocumentsDetails from '@/components/static/DocumentsDetails.vue';
import { mapGetters, mapActions, mapMutations } from 'vuex';
import { workService } from '../Works/services';
import moment from 'moment';
import { documentService } from '../service/document.service';
import eventBus from '@/shared/event.bus';
import { find } from 'lodash';
import { queryConstant } from '@/shared/queryConstant';
import ConfirmModal from '@/components/static/ConfirmModal';
import {estimationService, precarityService, simulationService} from './services';
import {constants} from '@/shared/constants';
import Address from '@/views/Simulations/Address';
import Fiche from './Fiche';
import addressValidation from './validation/address-validation';
import ficheValidation from './validation/fiche-validation';
import router from '../../plugins/vue-router';
import {estimationMapper} from './services/estimation.mapper';
import Vue from 'vue';
import {helpers} from '@/shared/helper';
import SimulationInfoModal from '@/views/Simulations/SimulationInfoModal';
// import SimulationWizzard from './SimulationWizzard.vue';

Vue.directive('disable-all-after-carried-out', {
  componentUpdated: (el, binding) => {
    if (binding.value !== 'TO_BE_TRANSFORMED') {
      return;
    }
    setTimeout(() => {
      const tags = ['input', 'select', 'checkbox'];
      tags.forEach(tagName => {
        const nodes = el.getElementsByTagName(tagName);
        for (let i = 0; i < nodes.length; i++) {
          nodes[i].disabled = true;
          nodes[i].classList.add('like-input');
        }
      });
    }, 1);
  }
});

const CONFIRM_SAVE_ESTIMATIONS= 'confirm-save-estimations';
const CONFIRM_LOSE_ESTIMATIONS= 'confirm-lose-simulation';
const CONFIRM_DELETE_ADRESSE= 'confirm-delete-adresse';
const CONFIRM_DELETE_FICHE= 'confirm-delete-fiche';

export default {
  components: {
    Fiche,
    DocumentsActions,
    DocumentsList,
    DocumentsDetails,
    ConfirmModal,
    Address,
    SimulationInfoModal
  },
  name: 'AddSimulation',
  data() {
    return {
      currentTab: 1,
      edit: null,
      selectedAddress: null,
      selectedFiche: null,
      tabsAddress: [],
      tabAddressIndex: 0,
      tabsAddressDelete: null,
      tabsFiche: [],
      tabFicheIndex: 0,
      tabsFicheDelete: null,
      departments: constants.DEPARTEMENTS,
      applicationSectors: constants.APPLICATION_SECTORS,
      workTypes: [],
      selectDocuments: [],
      simulationForm: {
        name: '',
        deliveryDate: ''
      },
      customFilter: queryConstant.setDefaultCustomFilter(),
      queryConfig: queryConstant.DOCUMENT_CONFIG,
      selectedRadio: null,
      optionsRadio: [
        { text: 'Oui', value: 'true' },
        { text: 'Non', value: 'false' }
      ],
      modalId: '',
      modalContent: '',
      confirmLoader: false
    };
  },
  validations: {
    tabsAddress: addressValidation,
    tabsFiche: ficheValidation
  },
  mounted() {
    this.getDocumentsTypesAction();
    this.getPeriodsAction();
    if (this.$route.params['id']) {
      // case of update
      this.edit = true;
      const id = this.$route.params['id'];
      this.fetchSimulation(id);
      this.mapEstimations(id);
    } else {
      // case of add
      this.$store.commit('document/setDocuments', []);
      this.resetSimulationAction();
    }
    eventBus.$on('reloadDocuments', (documentsIds) => {
      this.selectDocuments = []
      if (documentsIds) {
        this.$root.$emit('bv::hide::modal', 'addDocumet');
        eventBus.$emit('setCurrentStep_One');
        this.getDocumentsAction({
          id: this.simulation.id,
          customFilter: this.customFilter
        });
      }
    });
  },
  computed: {
    ...mapGetters('document', ['getDocuments', 'getDocumentsTypes']),
    ...mapGetters('simulation', { simulation: 'getSimulation' }),
    ...mapGetters('loader', { loading: 'getLoading' }),
    ...mapGetters('loader', {saveSimulationLoader: 'getSaveSimulationLoader'}),
    ...mapGetters('period', {periods: 'getPeriods'}),
    ...mapGetters('account', {userInfo: 'getCurrentUser'}),
    tabFicheByAddress() {
      const tabAddr = this.tabsAddress[this.selectedAddress];
      let ficheByAddr = [];
      if (tabAddr) {
        ficheByAddr = this.tabsFiche.filter(value =>
                value.addressIndex === tabAddr.tabAddressIndex
        );
      }
      return ficheByAddr;
    }
  },
  methods: {
    ...mapActions('document', ['getDocumentsAction', 'getDocumentsTypesAction',]),
    ...mapActions('notification', ['openModal', 'closeModal']),
    ...mapActions('simulation', ['persistEstimationsAction', 'resetSimulationAction',]),
    ...mapActions('period', ['getPeriodsAction',]),
    ...mapMutations('document', ['setSelectedDocuments']),
    openSimulationInfoModal() {
      this.openModal({instance: this.$root, id: 'simulation-info-modal'});
    },
    persistEstimations() {
      estimationService.persistEstimations(this.tabsAddress, this.tabsFiche, this.simulation.id);
    },
    loseSimulation() {
      simulationService.validateOrLose(this.simulation.id, true).then(() => {
        router.router.push('/simulations', Function);
      });
    },
    fetchSimulation(id) {
      workService.fetchWorkById(id).then(result => {
          this.$store.commit('simulation/setSimulation', result);
          this.$store.dispatch('document/getDocumentsAction', {
            id: id,
            customFilter: this.customFilter
          });
          this.simulationForm = {
            name: result.name,
            deliveryDate: result.deliveryDate
          };
          this.simulationForm.deliveryDate = moment(
            this.simulationForm.deliveryDate,
            'x'
          ).format('YYYY-MM-DD');
        }, error => {
          console.log(error);
        }
      );
    },
    selectDocument(id) {
      const index = this.selectDocuments.indexOf(id);
      if (index > -1) {
        this.selectDocuments.splice(index, 1);
      } else {
        this.selectDocuments.push(id);
      }
      const docs = [];
      const allDocs = JSON.parse(JSON.stringify(this.getDocuments));
      this.selectDocuments.forEach((docId) => {
        docs.push(find(allDocs, { id: docId }));
      });
      if (docs && docs.length) {
        this.mapDocumentTypes(docs);
      }
    },
    mapDocumentTypes(docs) {
      const documents = docs;
      documents.forEach(doc => {
        const types = [];
        if (doc.types) {
          doc.types.forEach(type => {
            types.push(find(this.getDocumentsTypes, { code: type }));
          });
        }
        doc.types = types;
      });
      this.setSelectedDocuments(documents);
    },
    downloadDocuments() {
      documentService.downloadDocuments(this.selectDocuments);
    },
    applyFilter(event) {
      this.selectDocuments = [];
      this.customFilter = event.filter.custom;
      this.getDocumentsAction({
        id: parseInt(this.$route.params['id'], 10),
        customFilter: this.customFilter
      });
    },
    newTabAdresse() {
      estimationService.newTabAdresse(this.tabsAddress, this.$v, this.tabAddressIndex++);
    },
    deleteTabAdresse() {
      this.tabsFiche = this.tabsFiche.filter(tabFiche => tabFiche.addressIndex !== this.tabsAddressDelete);
      this.tabsAddress = this.tabsAddress.filter(addr => addr.tabAddressIndex !== this.tabsAddressDelete);
      this.hideConfirmationAdresseModal();
    },
    newTabFiche() {
      estimationService.newTabFiche(this.tabsAddress, this.tabsFiche, this.$v, this.selectedAddress, this.tabFicheIndex++);
    },
    deleteTabFiche() {
      this.tabsFiche = this.tabsFiche.filter(tabFiche => tabFiche.tabFicheIndex !== this.tabsFicheDelete);
      this.hideConfirmationFicheModal();
    },
    colapseCard(e) {
      const element = e.target;
      const colapsed = element.getAttribute('aria-expanded') === 'true' ? 'false' : 'true';
      element.setAttribute('aria-expanded', colapsed);
    },
    modelConfirm() {
      switch (this.modalId) {
        case CONFIRM_SAVE_ESTIMATIONS:
          this.confirmLoader = true;
          this.persistEstimations();
          break;
        case CONFIRM_LOSE_ESTIMATIONS:
          this.loseSimulation();
          break;
        case CONFIRM_DELETE_ADRESSE:
          this.deleteTabAdresse();
          break;
        case CONFIRM_DELETE_FICHE:
          this.deleteTabFiche();
          break;
        default:
          console.log('modelConfirm error');
      }
    },
    openConfirmLoseModal() {
      if (this.tabsFiche.find(tab => tab.id !== null) === undefined) {
        this.modalId = 'confirm-lose-simulation';
        this.modalContent = 'would-you-like-to-lose-simulation';
        this.doOpenConfirmModal();
      } else {
        if (helpers.hasRoutingHistory()) {
          router.router.back();
        } else {
          router.router.push('/simulations', Function);
        }
      }
    },
    openConfirmSaveModal() {
      let isFormInvalid = false;
      console.log(this.tabsAddress.length, this.tabsFiche.length)
      if (this.tabsAddress.length && this.tabsFiche.length) {
        this.tabsAddress.forEach(tabAddress => {
          const res = this.tabsFiche.find(tabFiche => tabFiche.addressIndex === tabAddress.tabAddressIndex);
          if (!res) {
            isFormInvalid = true;
            return;
          }
        })
      } else {
        isFormInvalid = true;
      }
      console.log(!isFormInvalid, !this.$v.tabsAddress.$invalid , !this.$v.tabsFiche.$invalid);
      if (!isFormInvalid && !this.$v.tabsAddress.$invalid && !this.$v.tabsFiche.$invalid) {
        this.modalId = 'confirm-save-estimations';
        this.modalContent = 'would-you-like-to-save-estimations';
        this.doOpenConfirmModal();
      } else {
        this.$v.tabsAddress.$touch();
        this.$v.tabsFiche.$touch();
        Vue.prototype.$notification.warning('Merci de renseigner tous les champs obligatoires');
      }
    },
    hideConfirmationModal() {
      switch (this.modalId) {
        case CONFIRM_DELETE_ADRESSE:
          this.tabsAddressDelete = null;
          break;
        case CONFIRM_DELETE_FICHE:
          this.tabsFicheDelete = null
          break;
        default:
          console.log('hideConfirmationModal error');
      }
      this.closeModal({instance: this.$root, id: this.modalId});
    },
    openConfirmationAdresseModal(idItem) {
      this.tabsAddressDelete = idItem;
      this.modalId = CONFIRM_DELETE_ADRESSE;
      this.modalContent = 'would-you-like-to-delete-the-address';
      this.doOpenConfirmModal();
    },
    hideConfirmationAdresseModal() {
      this.tabsAddressDelete = null;
      this.hideConfirmationModal();
    },
    openConfirmationFicheModal(idItem) {
      this.tabsFicheDelete = idItem;
      this.modalId = CONFIRM_DELETE_FICHE;
      this.modalContent = 'would-you-like-to-delete-the-fiche';
      this.doOpenConfirmModal();
    },
    hideConfirmationFicheModal() {
      this.tabsFicheDelete = null;
      this.hideConfirmationModal();
    },
    doOpenConfirmModal() {
      setTimeout(() => {
        this.openModal({instance: this.$root, id: this.modalId});
      }, 1);
    },
    fetchCityByZipCode(address) {
      estimationService.fetchCityByZipCode(this.tabsFiche, this.departments, address);
    },
    updatePrecarities(address) {
      estimationService.updatePrecarities(this.tabsFiche, address);
    },
    workTypeBySector(tabFiche) {
      tabFiche.workType.$model = '';
      tabFiche.ficheNumber.$model = '';
      tabFiche.fiches.$model = '';
      tabFiche.workTypes.$model = this.applicationSectors.find(s => s.value === tabFiche.activityArea.$model).types;
    },
    getFiches(tabFiche) {
      estimationService.fetchFiches(tabFiche);
    },
    fetchPrecarity(tabFiche) {
      const periodId = tabFiche.$model.period.id;
      const departmentCode = tabFiche.$model.departmentCode;
      precarityService.fetchPrecarity(periodId, departmentCode).then(res => {
        tabFiche.precarityControl.id.$model = res.id;
        tabFiche.precarityControl.periodId.$model = tabFiche.$model.period.id;
        tabFiche.precarityControl.department.$model = res.departementCode;
        tabFiche.precarityControl.couplePercentagePrecarityByDepartment.$model = res.percentHigh;
        tabFiche.precarityControl.couplePercentageBigPrecarityByDepartment.$model = res.percentLow;
      });
    },
    setPeriods(tabFiche) {
      estimationService.setPeriod(tabFiche, this.periods);
    },
    addressByFiche(tabFiche) {
      return this.tabsAddress.filter(addr => addr.tabAddressIndex === tabFiche.addressIndex);
    },
    getFormConditions(tabFiche){
      estimationService.getFormConditions(tabFiche);
      this.fetchPrecarity(tabFiche);
    },
    checkConditions(tabFiche){
      estimationService.checkConditions(tabFiche);
    },
    mapEstimations(simulationId) {
      simulationService.fetchEstimationsBySimulationId(simulationId).then(estimations => {
        if (estimations.length === 0 && this.userInfo.clientType !== 'B2B') {
          this.openSimulationInfoModal();
        }
        estimations.forEach(estimation => {
          const address = estimationMapper.mapAddresses(estimation, this.tabAddressIndex);
          this.tabsAddress.push(address);
          estimation.operationDetails.forEach(operationDetail => {
            this.tabsFiche.push(
                estimationMapper.mapFiches(
                    operationDetail,
                    address,
                    this.periods,
                    this.tabAddressIndex,
                    this.tabFicheIndex++)
            );
          });
          this.tabAddressIndex++;
        });
      });
    }
  },
  destroyed() {
    eventBus.$off('reloadDocuments');
  }
};
</script>

<style lang='scss'>
.min-h {
  min-height: 48px;
}
.height-doc {
  min-height: 320px;
  max-height: 320px;
}
/*b-form-select class*/
.custom-select {
  height: calc(1.5em + 0.75rem + 15px);
}
.form-row > .col, .form-row > [class*='col-'] {
  padding-right: 40px;
  padding-left: 5px;
}
</style>
